import {
  BankAccountLiteModel,
  useGetBankAccounts,
} from 'api-hooks/bank-account';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { transformLabel } from 'common/utils/string';
import CustomFormControl from 'components/elements/custom-form-control';
import Select from 'components/elements/master/select-input';
import useGenerateSelectProps from 'hooks/use-generate-select-props';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

function transformer(item: BankAccountLiteModel): Option {
  return {
    id: item.id,
    label: transformLabel([item.code, item.accountNumber]),
  };
}

export interface BankAccountFilterSelectInputProps {
  label?: string;
  placeholder?: string;
  onClose?: () => void;
  value?: string;
  onSelected?: (value?: string) => void;
  noMargin?: boolean;
  required?: boolean;
}

export default function BankAccountFilterSelectInput(
  props: BankAccountFilterSelectInputProps,
) {
  const { t } = useTranslation();
  const {
    label = t('common:bank_account'),
    placeholder = t('common:select_bank_account'),
    value,
    onSelected,
    required,
  } = props;

  const query = useGetBankAccounts({
    params: {
      limit: -1,
    },
  });

  const { options, value: _value } = useGenerateSelectProps({
    query,
    transformer,
    value,
  });

  const { pathname } = useRouter();

  const _required = React.useMemo(() => {
    switch (pathname) {
      case NavigationRoutes.BankMutationReport:
        return true;
      default:
        return required;
    }
  }, [pathname, required]);

  return (
    <CustomFormControl
      label={label}
      noMargin={props.noMargin}
      required={_required}
    >
      <Select
        type="select"
        placeholder={placeholder}
        required={_required}
        options={options}
        value={_value}
        onChange={(params: any) => {
          onSelected?.(params?.option?.id);
        }}
      />
    </CustomFormControl>
  );
}
